export const servicePages = {
  "softwareentwicklung": {
    title: "Softwareentwicklung",
    subtitle: "Individuelle Software, die Prozesse vereinfacht und Wachstum ermöglicht",
    date: "2026-03-27",
    image:
      "https://images.unsplash.com/photo-1515879218367-8466d910aaa4?q=80&w=2070&auto=format&fit=crop",
    sections: [
      {
        heading: "Worum es geht",
        content: `
          Wir entwickeln Software, die exakt zu Ihren Abläufen passt. Statt Ihre Prozesse an Standardsoftware anzupassen, bauen wir Anwendungen, Portale und interne Tools so, dass sie Ihre Arbeitsweise unterstützen, Daten sauber verarbeiten und mit Ihrem Unternehmen mitwachsen.
        `,
      },
      {
        heading: "Typische Einsatzfelder",
        content: `
          <ul>
            <li>Interne Fachanwendungen für operative Teams</li>
            <li>Kundenportale und Service-Plattformen</li>
            <li>Digitale Freigabe-, Prüf- und Verwaltungsprozesse</li>
            <li>Branchenspezifische Tools mit individueller Logik</li>
          </ul>
        `,
      },
      {
        heading: "Unser Ansatz",
        content: `
          Wir starten mit einem klaren Verständnis Ihrer Abläufe, definieren die Kernfunktionen und setzen schnell einen belastbaren ersten Stand um. Architektur, Datenmodell und Nutzerführung werden so aufgebaut, dass spätere Erweiterungen nicht zur Last werden.
        `,
      },
      {
        heading: "Ihr Vorteil",
        content: `
          Sie erhalten keine generische Software, sondern ein System mit echter fachlicher Passung. Das reduziert manuelle Arbeit, erhöht Transparenz und schafft eine Grundlage, auf der weitere Digitalisierung sicher aufbauen kann.
        `,
      },
    ],
  },
  "systemanbindungen": {
    title: "Systemanbindungen (ERP, CRM, DATEV)",
    subtitle: "Systeme sauber verbinden statt Daten doppelt pflegen",
    date: "2026-03-27",
    image:
      "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?q=80&w=2070&auto=format&fit=crop",
    sections: [
      {
        heading: "Worum es geht",
        content: `
          Viele Unternehmen arbeiten gleichzeitig mit ERP-, CRM-, Finanz- und Spezialsystemen. Ohne saubere Anbindungen entstehen Medienbrüche, doppelte Datenerfassung und unnötige Fehler. Wir verbinden Systeme so, dass Informationen verlässlich zwischen ihnen fließen.
        `,
      },
      {
        heading: "Was wir anbinden",
        content: `
          <ul>
            <li>ERP-Systeme für Prozesse, Aufträge und Stammdaten</li>
            <li>CRM-Systeme für Vertrieb, Kundenkontakt und Service</li>
            <li>DATEV-nahe Prozesse für Finanz- und Buchhaltungsabläufe</li>
            <li>Drittsysteme, Plattformen und individuelle Fachlösungen</li>
          </ul>
        `,
      },
      {
        heading: "Wie wir vorgehen",
        content: `
          Wir analysieren Datenflüsse, Verantwortlichkeiten und technische Schnittstellen. Anschließend definieren wir, welche Daten in welche Richtung laufen sollen, welche Prüfungen nötig sind und wie Fehlerfälle sauber behandelt werden.
        `,
      },
      {
        heading: "Ihr Vorteil",
        content: `
          Weniger manuelle Übertragungen, konsistentere Daten und stabilere Abläufe. Gerade bei wachsenden Unternehmen schaffen gut geplante Anbindungen einen großen Hebel für Effizienz und Skalierbarkeit.
        `,
      },
    ],
  },
  "systemerweiterung": {
    title: "Systemerweiterung",
    subtitle: "Bestehende Software sinnvoll erweitern statt unnötig neu bauen",
    date: "2026-03-27",
    image:
      "https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=2072&auto=format&fit=crop",
    sections: [
      {
        heading: "Worum es geht",
        content: `
          Häufig ist die vorhandene Systemlandschaft nicht falsch, sondern nur unvollständig. Wir erweitern bestehende Anwendungen um Funktionen, Module und Integrationen, damit Sie mehr aus Ihrer aktuellen IT herausholen können.
        `,
      },
      {
        heading: "Typische Erweiterungen",
        content: `
          <ul>
            <li>Zusätzliche Fachlogik und Workflows</li>
            <li>Admin- und Reporting-Bereiche</li>
            <li>Kunden- oder Mitarbeiterzugänge</li>
            <li>Module für Datenimport, Export oder Freigaben</li>
          </ul>
        `,
      },
      {
        heading: "Worauf wir achten",
        content: `
          Erweiterungen müssen zur bestehenden Architektur passen. Deshalb prüfen wir technische Grenzen, Codequalität, Datenmodell und Betriebsszenarien, bevor wir neue Funktionen einführen. So vermeiden wir, dass Erweiterungen später zum Risiko werden.
        `,
      },
      {
        heading: "Ihr Vorteil",
        content: `
          Sie investieren gezielt in die Funktionen, die echten Mehrwert liefern, ohne Ihre bestehende Systemwelt komplett zu ersetzen. Das spart Zeit, Budget und internen Umstellungsaufwand.
        `,
      },
    ],
  },
  "buchungssysteme": {
    title: "Buchungssysteme",
    subtitle: "Digitale Termin-, Ressourcen- und Buchungsprozesse ohne Reibung",
    date: "2026-03-27",
    image:
      "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?q=80&w=2070&auto=format&fit=crop",
    sections: [
      {
        heading: "Worum es geht",
        content: `
          Buchungssysteme müssen mehr leisten als freie Termine anzeigen. Sie müssen Verfügbarkeiten, Regeln, Rollen, Bestätigungen und Folgeprozesse sauber abbilden. Wir entwickeln Buchungslösungen, die genau zu Ihrem Geschäftsmodell passen.
        `,
      },
      {
        heading: "Typische Anforderungen",
        content: `
          <ul>
            <li>Termin- und Ressourcenverwaltung</li>
            <li>Mehrstufige Buchungslogik und Freigaben</li>
            <li>Zahlungs- oder Abrechnungsanbindung</li>
            <li>Automatische Bestätigungen und Erinnerungen</li>
          </ul>
        `,
      },
      {
        heading: "Für wen das relevant ist",
        content: `
          Buchungssysteme sind besonders relevant für Dienstleister, interne Serviceeinheiten, Beratungsangebote, Schulungen, Vermietung, Gesundheitsbereiche und andere termin- oder ressourcenbasierte Geschäftsmodelle.
        `,
      },
      {
        heading: "Ihr Vorteil",
        content: `
          Ein gut aufgebautes Buchungssystem reduziert Abstimmungsaufwand, erhöht Auslastung und sorgt für einen professionelleren Ablauf für Kunden und interne Teams.
        `,
      },
    ],
  },
  "prozessautomatisierung": {
    title: "Prozessautomatisierung",
    subtitle: "Wiederkehrende Arbeit reduzieren und Abläufe verlässlich skalieren",
    date: "2026-03-27",
    image:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?q=80&w=2070&auto=format&fit=crop",
    sections: [
      {
        heading: "Worum es geht",
        content: `
          Viele Abläufe in Backoffice, Finance, Operations oder HR bestehen aus wiederkehrenden manuellen Schritten. Wir automatisieren solche Prozesse, damit Informationen schneller verarbeitet werden und Mitarbeiter sich auf wertschöpfende Aufgaben konzentrieren können.
        `,
      },
      {
        heading: "Typische Automatisierungen",
        content: `
          <ul>
            <li>Datenübernahmen zwischen Systemen</li>
            <li>Freigabe- und Eskalationsprozesse</li>
            <li>Bearbeitung standardisierter Anfragen</li>
            <li>Statusupdates, Benachrichtigungen und Folgeaktionen</li>
          </ul>
        `,
      },
      {
        heading: "Unser Vorgehen",
        content: `
          Wir identifizieren zuerst die Prozesse mit dem größten Hebel. Danach definieren wir klare Regeln, Schnittstellen und Ausnahmen. Automatisierung funktioniert dann gut, wenn nicht nur der Idealfall, sondern auch die Praxis sauber berücksichtigt wird.
        `,
      },
      {
        heading: "Ihr Vorteil",
        content: `
          Weniger Fehler, geringere Bearbeitungszeiten und bessere Skalierbarkeit. Gerade bei wachsendem Volumen schafft Prozessautomatisierung schnell messbare Entlastung.
        `,
      },
    ],
  },
  "ki-tools": {
    title: "Einführung von KI-Tools",
    subtitle: "KI sinnvoll in bestehende Teams und Abläufe integrieren",
    date: "2026-03-27",
    image:
      "https://images.unsplash.com/photo-1677442136019-21780ecad995?q=80&w=2070&auto=format&fit=crop",
    sections: [
      {
        heading: "Worum es geht",
        content: `
          KI-Tools entfalten ihren Wert erst dann, wenn sie in reale Arbeitsprozesse eingebunden werden. Wir unterstützen Unternehmen bei der Einführung von Chatbots, Copilots und KI-gestützten Assistenten, die Teams im Alltag tatsächlich entlasten.
        `,
      },
      {
        heading: "Typische Einsatzszenarien",
        content: `
          <ul>
            <li>Interne Wissensassistenten für Teams</li>
            <li>Unterstützung bei Recherche, Texten und Analyse</li>
            <li>Automatisierte Vorqualifizierung von Anfragen</li>
            <li>KI-Unterstützung in Service- und Verwaltungsprozessen</li>
          </ul>
        `,
      },
      {
        heading: "Worauf es ankommt",
        content: `
          Neben der Auswahl des richtigen Tools sind Governance, Datenschutz, Rollen, Freigaben und Prompt-Design entscheidend. Wir achten darauf, dass KI nicht isoliert eingeführt wird, sondern zu Ihren Anforderungen und Risiken passt.
        `,
      },
      {
        heading: "Ihr Vorteil",
        content: `
          Sie erhalten nicht nur Zugang zu neuen Tools, sondern einen praktikablen Einsatzrahmen. So entstehen echte Produktivitätsgewinne statt zusätzlicher Komplexität.
        `,
      },
    ],
  },
  "webseiten-landingpages": {
    title: "Webseiten & Landingpages",
    subtitle: "Digitale Auftritte, die Vertrauen schaffen und Anfragen erzeugen",
    date: "2026-03-27",
    image:
      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=2070&auto=format&fit=crop",
    sections: [
      {
        heading: "Worum es geht",
        content: `
          Ihre Website ist oft der erste echte Kontaktpunkt mit potenziellen Kunden. Wir entwickeln Websites und Landingpages, die klar kommunizieren, professionell wirken und auf konkrete Ziele wie Anfragen, Buchungen oder Bewerbungen ausgerichtet sind.
        `,
      },
      {
        heading: "Was wir umsetzen",
        content: `
          <ul>
            <li>Unternehmenswebsites mit klarer Positionierung</li>
            <li>Landingpages für Kampagnen und Produkte</li>
            <li>Kontakt- und Lead-Strecken</li>
            <li>Performante und mobileoptimierte Frontends</li>
          </ul>
        `,
      },
      {
        heading: "Unser Fokus",
        content: `
          Gute Webprojekte verbinden Inhalt, Struktur, Design und Technik. Deshalb achten wir auf klare Nutzerführung, schnelle Ladezeiten, sinnvolle Inhalte und eine technische Basis, die später erweiterbar bleibt.
        `,
      },
      {
        heading: "Ihr Vorteil",
        content: `
          Sie erhalten einen digitalen Auftritt, der nicht nur gut aussieht, sondern auch in Vertrieb, Marketing und Kommunikation tatsächlich funktioniert.
        `,
      },
    ],
  },
  "online-shops": {
    title: "Online-Shops",
    subtitle: "Digitale Verkaufsprozesse, die technisch sauber und operativ tragfähig sind",
    date: "2026-03-27",
    image:
      "https://images.unsplash.com/photo-1556740749-887f6717d7e4?q=80&w=2070&auto=format&fit=crop",
    sections: [
      {
        heading: "Worum es geht",
        content: `
          Ein Online-Shop ist mehr als Produktdarstellung und Checkout. Entscheidend sind Produktdaten, Zahlungslogik, Versandprozesse, Systemanbindung und ein sauberer Betrieb. Wir entwickeln und erweitern Shop-Lösungen mit Blick auf das gesamte Geschäftsmodell.
        `,
      },
      {
        heading: "Typische Bausteine",
        content: `
          <ul>
            <li>Produkt- und Kataloglogik</li>
            <li>Warenkorb, Checkout und Zahlungsanbindung</li>
            <li>Schnittstellen zu ERP, CRM und Versand</li>
            <li>Individuelle Frontends und Conversion-orientierte Nutzerführung</li>
          </ul>
        `,
      },
      {
        heading: "Unser Ansatz",
        content: `
          Wir betrachten Shop-Projekte nicht isoliert, sondern im Zusammenspiel mit Lager, Auftragsabwicklung, Marketing und Service. So entstehen Lösungen, die nicht nur online gut aussehen, sondern im Betrieb belastbar bleiben.
        `,
      },
      {
        heading: "Ihr Vorteil",
        content: `
          Ein sauber aufgebauter Shop reduziert operative Reibung, verbessert das Kundenerlebnis und schafft eine stabile Basis für Wachstum im digitalen Vertrieb.
        `,
      },
    ],
  },
  "dashboards-visualisierung": {
    title: "Dashboards & Visualisierung",
    subtitle: "Kennzahlen verständlich machen und Entscheidungen beschleunigen",
    date: "2026-03-27",
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=2070&auto=format&fit=crop",
    sections: [
      {
        heading: "Worum es geht",
        content: `
          Dashboards machen Daten nur dann wertvoll, wenn sie die richtigen Fragen beantworten. Wir entwickeln Visualisierungen, die operative und strategische Entscheidungen unterstützen, statt nur Zahlen anzuzeigen.
        `,
      },
      {
        heading: "Typische Inhalte",
        content: `
          <ul>
            <li>Vertriebs- und Pipeline-Dashboards</li>
            <li>Operations- und Leistungskennzahlen</li>
            <li>Management-Übersichten für Führungsteams</li>
            <li>Individuelle Reports für Fachbereiche</li>
          </ul>
        `,
      },
      {
        heading: "Technische Umsetzung",
        content: `
          Wir arbeiten mit gängigen BI- und Frontend-Technologien wie Power BI oder React-basierten Dashboard-Lösungen. Wichtig ist dabei nicht nur das Visual, sondern vor allem die Qualität und Struktur der zugrundeliegenden Daten.
        `,
      },
      {
        heading: "Ihr Vorteil",
        content: `
          Statt fragmentierter Excel-Sichten erhalten Sie eine verlässliche Entscheidungsgrundlage mit klarer Priorisierung, schnellerer Auswertung und besserer Transparenz.
        `,
      },
    ],
  },
  "datenanalyse": {
    title: "Datenanalyse",
    subtitle: "Aus vorhandenen Daten nutzbare Erkenntnisse ableiten",
    date: "2026-03-27",
    image:
      "https://images.unsplash.com/photo-1518186285589-2f7649de83e0?q=80&w=2070&auto=format&fit=crop",
    sections: [
      {
        heading: "Worum es geht",
        content: `
          Viele Unternehmen verfügen bereits über wertvolle Daten, nutzen sie aber nur begrenzt. Wir helfen dabei, Datenquellen zu strukturieren, Zusammenhänge sichtbar zu machen und daraus fundierte Entscheidungen abzuleiten.
        `,
      },
      {
        heading: "Typische Fragestellungen",
        content: `
          <ul>
            <li>Wo entstehen Engpässe oder Verluste?</li>
            <li>Welche Kunden, Prozesse oder Produkte treiben Ergebnisse?</li>
            <li>Welche Muster sind im Tagesgeschäft bisher verborgen?</li>
            <li>Wie lassen sich Daten für operative Steuerung nutzbar machen?</li>
          </ul>
        `,
      },
      {
        heading: "Unser Vorgehen",
        content: `
          Wir strukturieren die Datenbasis, bereiten Informationen fachlich auf und entwickeln Auswertungen, die auf echte Geschäftsfragen einzahlen. Damit entsteht Analyse nicht als Selbstzweck, sondern als Arbeitsgrundlage für Teams und Führungskräfte.
        `,
      },
      {
        heading: "Ihr Vorteil",
        content: `
          Sie gewinnen Klarheit über Prioritäten, erkennen Potenziale schneller und schaffen eine deutlich bessere Basis für operative und strategische Entscheidungen.
        `,
      },
    ],
  },
  "kpi-tracking": {
    title: "KPI-Tracking",
    subtitle: "Relevante Kennzahlen definieren, messen und konsequent nutzen",
    date: "2026-03-27",
    image:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop",
    sections: [
      {
        heading: "Worum es geht",
        content: `
          KPI-Tracking schafft nur dann Nutzen, wenn die richtigen Kennzahlen gewählt werden. Wir helfen dabei, Messgrößen zu definieren, die wirklich zum Geschäftsmodell, zu den Teams und zu den Unternehmenszielen passen.
        `,
      },
      {
        heading: "Typische KPI-Bereiche",
        content: `
          <ul>
            <li>Vertrieb und Conversion</li>
            <li>Projekt- und Lieferperformance</li>
            <li>Support- und Servicequalität</li>
            <li>Finanzielle und operative Effizienz</li>
          </ul>
        `,
      },
      {
        heading: "Von der Kennzahl zum Steuerungsinstrument",
        content: `
          Wir definieren nicht nur KPIs, sondern auch Datenquelle, Berechnungslogik, Verantwortlichkeiten und Visualisierung. So werden Kennzahlen belastbar und im Alltag tatsächlich nutzbar.
        `,
      },
      {
        heading: "Ihr Vorteil",
        content: `
          Mehr Transparenz, bessere Priorisierung und eine klarere Steuerung. KPI-Tracking hilft, Diskussionen auf belastbare Daten zu stützen und Fortschritt sichtbar zu machen.
        `,
      },
    ],
  },
  "cloud-migration": {
    title: "Cloud Migration",
    subtitle: "Systeme sicher, kontrolliert und mit klarem Zielbild in moderne Umgebungen überführen",
    date: "2026-03-27",
    image:
      "https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=2072&auto=format&fit=crop",
    sections: [
      {
        heading: "Worum es geht",
        content: `
          Cloud Migration ist kein reiner Infrastrukturwechsel. Es geht darum, Anwendungen, Daten, Rechte, Prozesse und Verantwortlichkeiten so zu überführen, dass der Betrieb stabil bleibt und echte Vorteile entstehen.
        `,
      },
      {
        heading: "Typische Migrationen",
        content: `
          <ul>
            <li>Microsoft 365 und moderne Arbeitsplatzumgebungen</li>
            <li>Anwendungs- und Servermigrationen</li>
            <li>Datenmigrationen und Berechtigungsstrukturen</li>
            <li>Schrittweise Ablösung lokaler Altumgebungen</li>
          </ul>
        `,
      },
      {
        heading: "Unser Vorgehen",
        content: `
          Wir planen Zielarchitektur, Übergänge, Risiken und Prioritäten sauber vor. So werden kritische Abläufe geschützt und Migrationen in nachvollziehbaren Schritten umgesetzt statt mit unnötigem Betriebsrisiko.
        `,
      },
      {
        heading: "Ihr Vorteil",
        content: `
          Sie gewinnen mehr Flexibilität, modernere Arbeitsstrukturen und eine bessere Grundlage für zukünftige Digitalisierung, ohne die operative Stabilität aus dem Blick zu verlieren.
        `,
      },
    ],
  },
  "system-architektur": {
    title: "System Architektur",
    subtitle: "Technische Strukturen schaffen, die heute funktionieren und morgen tragfähig bleiben",
    date: "2026-03-27",
    image:
      "https://images.unsplash.com/photo-1516321310764-8d5a5f067f6f?q=80&w=2070&auto=format&fit=crop",
    sections: [
      {
        heading: "Worum es geht",
        content: `
          Systemarchitektur entscheidet darüber, ob neue Anforderungen schnell umgesetzt werden können oder ob jede Änderung teuer und riskant wird. Wir helfen dabei, Anwendungen, Datenflüsse und Systemgrenzen sauber zu strukturieren.
        `,
      },
      {
        heading: "Typische Themen",
        content: `
          <ul>
            <li>Aufteilung von Verantwortlichkeiten zwischen Systemen</li>
            <li>Saubere Datenmodelle und Integrationspunkte</li>
            <li>Skalierbare Architekturentscheidungen für Wachstum</li>
            <li>Reduktion technischer Komplexität und Altlasten</li>
          </ul>
        `,
      },
      {
        heading: "Unser Blick auf Architektur",
        content: `
          Gute Architektur ist nicht theoretisch, sondern praktisch. Sie muss fachliche Abläufe, Teamfähigkeit, Betrieb und zukünftige Erweiterbarkeit zusammenbringen. Genau darauf richten wir unsere Empfehlungen und Umsetzungen aus.
        `,
      },
      {
        heading: "Ihr Vorteil",
        content: `
          Weniger technische Reibung, klarere Systeme und eine bessere Entscheidungsbasis für neue Projekte. Das spart mittel- und langfristig erheblich Aufwand.
        `,
      },
    ],
  },
  "it-security-dsgvo": {
    title: "IT-Security & DSGVO",
    subtitle: "Sicherheit und Compliance in Systeme und Prozesse integrieren",
    date: "2026-03-27",
    image:
      "https://images.unsplash.com/photo-1563013544-824ae1b704d3?q=80&w=2070&auto=format&fit=crop",
    sections: [
      {
        heading: "Worum es geht",
        content: `
          IT-Sicherheit und Datenschutz sollten nicht erst am Ende eines Projekts betrachtet werden. Wir unterstützen dabei, Systeme so zu gestalten, dass Sicherheitsanforderungen und DSGVO-relevante Aspekte frühzeitig berücksichtigt werden.
        `,
      },
      {
        heading: "Typische Leistungen",
        content: `
          <ul>
            <li>Prüfung bestehender Systemlandschaften</li>
            <li>Identifikation technischer und organisatorischer Risiken</li>
            <li>DSGVO-konforme Gestaltung von Datenflüssen</li>
            <li>Empfehlungen für Rechte, Rollen, Backups und Schutzmaßnahmen</li>
          </ul>
        `,
      },
      {
        heading: "Pragmatisch statt formalistisch",
        content: `
          Unser Ziel ist kein überladener Maßnahmenkatalog, sondern eine realistische und umsetzbare Sicherheitsbasis. Besonders im Mittelstand ist entscheidend, dass Maßnahmen zum Alltag, zum Budget und zu den tatsächlichen Risiken passen.
        `,
      },
      {
        heading: "Ihr Vorteil",
        content: `
          Sie reduzieren Risiken, stärken Vertrauen in Ihre Systeme und schaffen eine belastbare Grundlage für zukünftige digitale Projekte und Audits.
        `,
      },
    ],
  },
};
